import { apiRequest } from 'utils/request'

export const getUser = () =>
  apiRequest({
    uri: '/users/current',
  })

export const acceptEula = () =>
  apiRequest({
    uri: '/users/eula-accepted/update',
    method: 'POST',
  })

export const updateUserSettings = ({ settings }) =>
  apiRequest({
    method: 'POST',
    uri: '/users/settings/update',
    body: {
      settings,
    },
  })

export const getAlerts = () =>
  apiRequest({
    uri: '/alerts',
  })

export const updateAlerts = (alertsData) =>
  apiRequest({
    method: 'POST',
    uri: '/alerts',
    body: [alertsData],
  })

export const getRecentlyViewed = () =>
  apiRequest({
    uri: '/users/recently-viewed',
  })

export const getFavoriteVehicles = () =>
  apiRequest({
    uri: '/users/vehicles',
  })

export const addFavoriteVehicle = ({ serialNumber }) =>
  apiRequest({
    uri: '/users/vehicles/add',
    method: 'POST',
    body: { serialNumber },
  })

export const removeFavoriteVehicle = ({ serialNumber }) =>
  apiRequest({
    uri: '/users/vehicles/remove',
    method: 'POST',
    body: { serialNumber },
  })

export const updateFavoriteVehicle = ({ serialNumber, customDescription }) =>
  apiRequest({
    uri: '/users/vehicles/update',
    method: 'PUT',
    body: { serialNumber, customDescription },
  })

export const reorderFavoriteVehicles = ({ serialNumbers }) =>
  apiRequest({
    uri: '/users/vehicles/reorder',
    method: 'POST',
    body: { serialNumbers },
  })

/**
 * Update the current user's own roles.
 * @param {{ roles: string[] }} params
 */
export const updateUserRoles = ({ roles }) =>
  apiRequest({
    uri: '/users/roles',
    method: 'POST',
    body: { roles },
  })

/**
 * Add or remove a single role from any user (developer-only tool).
 *
 * @param {{ userName: string, action: 'ADD'|'REMOVE', role: string }} params
 *   userName must be the raw un-encoded string (e.g. 'DOMAIN\\user' or 'first.last').
 *   encodeURIComponent() is applied here; passing an already-percent-encoded
 *   value will double-encode it (%5C → %255C) and the server will receive the
 *   wrong identifier.
 */
export const changeUserRole = ({ userName, action, role }) =>
  apiRequest({
    // Encode all three path segments: DTNA usernames can contain domain
    // prefixes (DOMAIN\user), spaces, or forward-slashes which would produce
    // a malformed URI and silently route to the wrong endpoint.
    uri: `/users/${encodeURIComponent(userName)}/roles/${encodeURIComponent(
      action
    )}/${encodeURIComponent(role)}`,
    method: 'POST',
  })
